import {Headline} from '../Headline'

export interface ErrorTemplateProps {
  title: string
  description?: string
  code?: string
}

export const ErrorTemplate = ({title, description, code}: ErrorTemplateProps) => (
  <div className={'flex h-screen w-full flex-col items-center justify-center p-4'}>
    <div className={'w-full max-w-md border border-gray-200 bg-white px-24 py-12'}>
      {title && (
        <Headline
          tag={'h1'}
          size={1}
          className={'mb-4 text-center'}
        >
          {title}
        </Headline>
      )}
      {description && <p className={'text-center'}>{description}</p>}
    </div>
    {code && <pre className={'m-12 w-full max-w-screen-lg overflow-auto rounded-lg bg-black p-8 text-white'}>{code}</pre>}
  </div>
)
